@if (items.length) {
  <div class="docs-param-list">
    <button type="button" class="docs-param-list__expand-all" (click)="toggleAll()">
      {{ allExpanded ? 'Collapse all' : 'Expand all' }}
    </button>

    @for (p of items; track p.name) {
      <div class="docs-param-list__row">
        <button
          type="button"
          class="docs-param-list__header"
          [attr.aria-expanded]="isExpanded(p.name)"
          (click)="toggle(p.name)"
        >
          <svg
            class="docs-param-list__chevron"
            [class.docs-param-list__chevron--open]="isExpanded(p.name)"
            width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
          >
            <path d="M4.5 2.5L8 6L4.5 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="docs-param docs-param-list__name">{{ p.name }}</span>
          <span class="docs-param-list__type">{{ p.type }}</span>
          @if (p.required) {
            <span class="docs-param-table__flag docs-param-list__flag">required</span>
          } @else if (p.defaultValue) {
            <span class="docs-param-list__flag">default: <span class="docs-param">{{ p.defaultValue }}</span></span>
          }
        </button>

        @if (isExpanded(p.name)) {
          <div class="docs-param-list__body">
            <p>{{ p.description }}</p>
            @if (p.accountScoped) { <div class="docs-callout__example">account-scoped: {{ p.accountScoped }}</div> }
            @if (p.example) { <div class="docs-callout__example">e.g. {{ p.example }}</div> }
          </div>
        }
      </div>
    }
  </div>
}
